import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CONSTANTS } from './constants';
import { AuthGuard } from './core/auth.guard';
import { MaintenancePageGuard } from './core/maintenance-page.guard';

const routes: Routes = [
  {
    path: CONSTANTS.ROUTES.HOME,
    loadChildren: () =>
      import('./feature/ping/ping.module').then((m) => m.PingModule),
    canActivate: [MaintenancePageGuard],
  },
  {
    path: CONSTANTS.ROUTES.SETTING_PAGE,
    loadChildren: () =>
      import('./feature/settings-lobby-page/settings-lobby-page.module').then(
        (m) => m.SettingsLobbyPageModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.QR_SCANNER,
    loadChildren: () =>
      import('./feature/scan-qr-page/scan-qr.module').then(
        (m) => m.ScanQrModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.EMP_DETAILS,
    loadChildren: () =>
      import('./feature/emp-details/emp-details.module').then(
        (m) => m.EmpDetailsModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.EMP_HIERARCHY,
    loadChildren: () =>
      import('./feature/emp-hierarchy/emp-hierarchy.module').then(
        (m) => m.EmpHierarchyModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.NEWS,
    loadChildren: () =>
      import('./feature/news-page/news-page.module').then(
        (m) => m.NewsPageModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.NEXT_MEETING_DETAILS,
    loadChildren: () =>
      import('./feature/meeting-details/meeting-details.module').then(
        (m) => m.MeetingDetailsModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.NOTIFICATIONS_PAGE,
    loadChildren: () =>
      import('./feature/notification-page/notification-page.module').then(
        (m) => m.NotificationPageModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.JOBS_PAGE,
    loadChildren: () =>
      import('./feature/jobs-page/jobs-page.module').then(
        (m) => m.JobsPageModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.PARKING,
    loadChildren: () =>
      import('./feature/parking-page/parking-page.module').then(
        (m) => m.ParkingPageModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.CLIC_GAME,
    loadChildren: () =>
      import('./feature/clic-game/clic-game.module').then(
        (m) => m.ClicGameModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.IT_ACCESSORY,
    loadChildren: () =>
      import('./feature/it-accessory/it-accessory.module').then(
        (m) => m.ItAccessoryModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.MY_PROFILE,
    loadChildren: () =>
      import('./feature/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: CONSTANTS.ROUTES.CALENDAR,
    loadChildren: () =>
      import('./feature/calendar/calendar.module').then(
        (m) => m.CalendarModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.MY_APPROVAL,
    loadChildren: () =>
      import('./feature/my-approvals/my-approvals.module').then(
        (m) => m.MyApprovalsModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.GUEST_RESERVATION,
    loadChildren: () =>
      import('./feature/guest-reservation/guest-reservation.module').then(
        (m) => m.GuestReservationModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.CAR_WASH,
    loadChildren: () =>
      import('./feature/car/car-wash/car-wash.module').then((m) => m.CarWashModule),
  },
  {
    path: CONSTANTS.ROUTES.CAR_SERVICES,
    loadChildren: () =>
      import('./feature/car/car-services/car-services.module').then(
        (m) => m.CarServicesModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.CAR_PER_DAY,
    loadChildren: () =>
      import('./feature/car/car-per-day/car-per-day.module').then(
        (m) => m.CarPerDayModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.SYSTEM_PASSWORD_RECOVERY,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './feature/laptop/windows/system-password-recovery/system-password-recovery.module'
      ).then((m) => m.SystemPasswordRecoveryModule),
  },
  {
    path: CONSTANTS.ROUTES.LAPTOP_RECOVERY_WITHOUT_USB,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './feature/laptop/windows/system-password-recovery-without-usb/system-password-recovery-without-usb.module'
      ).then((m) => m.RecoveryWithoutUsbModule),
  },
  {
    path: CONSTANTS.ROUTES.NEW_EMPLOYEE_LAPTOP,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./feature/laptop/windows/new-employee-laptop/new-employee-laptop.module').then(
        (m) => m.NewEmployeeLaptopModule
      ),
  },
   {
    path: CONSTANTS.ROUTES.NEW_EMPLOYEE_LAPTOP_MAC,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./feature/laptop/mac/new-employee-laptop-mac/new-employee-laptop-mac.module').then(
        (m) => m.NewEmployeeLaptopMacModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.SYSTEM_PASSWORD_RECOVERY_MAC,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './feature/laptop/mac/system-password-recovery-mac/system-password-recovery-mac.module'
      ).then((m) => m.SystemPasswordRecoveryMacModule),
  },
  {
    path: CONSTANTS.ROUTES.SYSTEM_PARTITION_RECOVERY,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './feature/laptop/windows/system-partition-recovery/system-partition-recovery.module'
      ).then((m) => m.SystemPartitionRecoveryModule),
  },
  {
    path: CONSTANTS.ROUTES.Sderot_Cafeteria,
    loadChildren: () =>
      import('./feature/cafeteria-popup/cafeteria-popup.module').then(
        (m) => m.CafeteriaPopupModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.SYSTEM_PASSWORD_RECOVERY_MAC_Boot,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './feature/laptop/mac/system-password-recovery-mac-boot/system-password-recovery-mac-boot.module'
      ).then((m) => m.SystemPasswordRecoveryMacBootModule),
  },
  {
    path: CONSTANTS.ROUTES.CAR_PER_DAY,
    loadChildren: () =>
      import('./feature/car/car-per-day/car-per-day.module').then(
        (m) => m.CarPerDayModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.CAR_ACCIDENT,
    loadChildren: () =>
      import('./feature/car/car-accident/car-accident.module').then(
        (m) => m.CarAccidentModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.MY_CAR_REQUEST,
    loadChildren: () =>
      import('./feature/car/my-request/my-request.module').then(
        (m) => m.MyRequestModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.TICKET_DETAILS,
    loadChildren: () =>
      import('./feature/car/ticket-details/ticket-details.module').then(
        (m) => m.TicketDetailsModule
      ),
  },
  {
    path: CONSTANTS.ROUTES.SCHEDULE_SERVICE,
    loadChildren: () =>
      import('./feature/car/schedule-service/schedule-service.module').then(
        (m) => m.ScheduleServiceModule
      ),
  },

   {
    path: CONSTANTS.ROUTES.VEHICLE_FAULT,
    loadChildren: () =>
      import('./feature/car/vehicle-fault/vehicle-fault.module').then(
        (m) => m.VehicleFaultModule
      ),
  },

  {
    path: CONSTANTS.ROUTES.CAR_ACCIDENT_STEP2,
    loadChildren: () =>
      import(
        './feature/car/car-accident/car-accident-step2/car-accident-step2.module'
      ).then((m) => m.CarAccidentStep2Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_ACCIDENT_STEP3,
    loadChildren: () =>
      import(
        './feature/car/car-accident/car-accident-step3/car-accident-step3.module'
      ).then((m) => m.CarAccidentStep3Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_ACCIDENT_STEP4,
    loadChildren: () =>
      import(
        './feature/car/car-accident/car-accident-step4/car-accident-step4.module'
      ).then((m) => m.CarAccidentStep4Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_PER_DAY_Step2,
    loadChildren: () =>
      import(
        './feature/car/car-per-day/car-per-day-step2/car-per-day-step2.module'
      ).then((m) => m.CarPerDayStep2Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_PER_DAY_Step3,
    loadChildren: () =>
      import(
        './feature/car/car-per-day/car-per-day-step3/car-per-day-step3.module'
      ).then((m) => m.CarPerdayStep3Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_PER_DAY_Step4,
    loadChildren: () =>
      import(
        './feature/car/car-per-day/car-per-day-step4/car-per-day-step4.module'
      ).then((m) => m.CarPerDayStep4Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_ACCIDENT_STEP5,
    loadChildren: () =>
      import(
        './feature/car/car-accident/car-accident-step5/car-accident-step5.module'
      ).then((m) => m.CarAccidentStep5Module),
  },
  {
    path: CONSTANTS.ROUTES.CAR_ACCIDENT_STEP6,
    loadChildren: () =>
      import(
        './feature/car/car-accident/car-accident-step6/car-accident-step6.module'
      ).then((m) => m.CarAccidentStep6Module),
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./feature/ping/maintenance-page/maintenance-page.module').then(
        (m) => m.MaintenancePageModule
      ),
  },
  {
    path: '**',
    redirectTo: CONSTANTS.ROUTES.HOME,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
